export const LIFE = {
  nickname: 'PRODUCTS.LIFE.nickname',
  lifeInsurance: true,
  icon: 'life'
};
